"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GarbageBinAbsent = function GarbageBinAbsent(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 443 443", className: "custom-icon" }, props),
    _react2.default.createElement("path", { d: "M274.2092 125.0527H230.383V105.08h-59.5144v19.9727H127.042v31.5358h147.1671v-31.5358zm-87.5728-4.2048h27.9785v4.2048h-27.9785v-4.2048zM260.2057 217.7207l2.975-45.3643H138.0711l9.9948 152.4231h60.0084c-7.8109-11.0727-12.4051-24.5695-12.4051-39.1201 0-36.3398 28.6419-66.1154 64.5364-67.9387z" }),
    _react2.default.createElement("path", { d: "M263.6973 233.3998c-28.8164 0-52.2601 23.4437-52.2601 52.2596s23.4437 52.26 52.26 52.26 52.2602-23.4437 52.2602-52.26-23.4437-52.2596-52.2601-52.2596zm28.4747 69.5848l-11.1495 11.1495-17.3252-17.3252-17.3253 17.3252-11.1495-11.1495 17.3253-17.3252-17.3253-17.3253 11.1495-11.1495 17.3253 17.3253 17.3252-17.3253 11.1495 11.1495-17.3252 17.3253 17.3252 17.3252z" })
  );
};

exports.default = GarbageBinAbsent;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/garbage-bin-absent.js
// module id = ../lib/egov-ui-kit/custom-icons/garbage-bin-absent.js
// module chunks = 504